export default __webpack_public_path__ + "static/media/finger.5b24e112.svg";